import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { PlanId } from "@/lib/plans/plans";
import { cn } from "@/lib/core/utils";

/** "Pro" / "Starter" pill next to things a higher plan unlocks. */
export function PlanBadge({
  plan,
  className,
}: {
  plan: Exclude<PlanId, "free">;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full border border-brand/30 bg-brand/10 px-2 py-0.5 text-[11px] leading-none font-semibold text-brand",
        className,
      )}
      data-testid={`plan-badge-${plan}`}
    >
      <Sparkles className="size-3" aria-hidden />
      {t(`plans.names.${plan}`)}
    </span>
  );
}
